module.exports = __webpack_public_path__ + "media/images/play-7d477c4ed6c9c8a5a0e4525344a2e08c.png";